import React, { Component }    from 'react';
import { connect }             from 'react-redux';
import EquipeItem              from './equipes_item';
import Equipe                  from './equipe';
import TopoComunicacao         from '../topo_comunicacao';
import { GetActionBg }         from '../../../../actions/scopoAction';
import bg_equipe               from "../../../../img/bg/bg_equipe.png";
import {GetEquipesAlunos,
        GetRegistroPostEquipe} from '../../../../actions/grupoAction';
import Filtro                  from '../../../../container/renderFiltro';
import registro                from "../../../../img/global/registro.png";



import '../../../../css/aluno/comunicacao/communication.css';
import '../../../../css/aluno/box.css';
import '../../../../css/aluno/comunicacao/communication_card.css';

class Equipes extends Component {

    constructor(props){
        super(props);
        this.state = {
                      load:false,
                      load2:false,
                      equipe:false
                    }
    }
    
    componentWillMount() {        
        this.props.GetActionBg(bg_equipe);
        this.props.GetEquipesAlunos(this.props.session.id).then((response)=>{
            this.setState({load:true})
        })
    }
    
    renderEquipe(val){
      setTimeout(() => {
        this.setState({load2:true,equ_id:val,equipe:<Equipe equ_id={val}/>});
       
       }, 100);

    }

    renderListaEquipes(){
        const margin = {"margin": "0 auto"}

        const ListaEquipes =  (this.props.checkSelect == null ? this.props.all_equipes_alunos.ativas : this.props.all_equipes_alunos.inativas);
        if (ListaEquipes.length>0) {
            return ListaEquipes.map((elem,i)=>{
                return <EquipeItem funcao={this.renderEquipe.bind(this,elem.equ_id)} dados={elem} key={i}/>
            })
        } else {
            return <img src={registro} style={margin} className="img-responsive" alt=""/>;
        }
      
    }

    render() {
        return (
            <div className="hud-middle-center active">
                <TopoComunicacao nome="Equipes"/>

                   <main className="hud-middle-center-content">
                    <div className="communications communications-with-side-big">

                        <div className="communication communication-with-decoration communication-active communication-expanded">
                            <div className="line-decoration"></div>
                            <div className="filtering filtering-short">
                                <div className="filtering-text">
                                    Timelines
                                </div>
                               <hr/>
                                <div className="filtering-actions">
                                  <Filtro/>
                                </div>
                            </div>
                            <div className="communication-cards">
                                {this.state.load ? this.renderListaEquipes() : "Carregando..."}
                           </div>
                        </div>
                    </div>

                   </main>
            </div>     
           
        );
    }
}

function mapStateToProps(state){  
    return {
            session            : state.auth.session,
            actionTopo         : state.scopoReducer.actionTopo,
            menu               : state.configReducer.menu,
            checkSelect        : state.scopoReducer.checkSelect,
            all_equipes_alunos : state.equipeReducer.all_equipes_alunos
           };
}

export default connect(mapStateToProps,{GetRegistroPostEquipe,GetEquipesAlunos,GetActionBg})(Equipes);




// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/equipe/equipes.js